import React, { useEffect, useState } from "react";
import { BreadCrumb } from "primereact/breadcrumb";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { useHistory, useParams } from "react-router-dom";
import { handleGetRequest } from "../../services/GetTemplate";
import { handlePutRequest } from "../../services/PutTemplate";
import { toast } from "react-toastify";
import { Dialog } from "primereact/dialog";
import ResetPasswordDialog from "./ResetPasswordDialog";
import LocationPicker from "../../components/customer/LocationPicker";
import AgentsManager from "../../components/customer/AgentsManager";
import GrantCreditDialog from "../../components/payment/GrantCreditDialog";
import CreditHistoryList from "../../components/payment/CreditHistoryList";
import { formatMoney } from "../../services/clientPaymentService";
import useViewOnly from "../../hooks/useViewOnly";
import styles from "./customer.module.scss";

function Customer() {
    const isClerk = localStorage.getItem("role") === "clerk";
    const viewOnly = useViewOnly();
    const isAdmin = localStorage.getItem("role") === "admin";
    const breadItems = [{ label: "Home", url: "/" }, { label: "Customers", url: "/customers" }, { label: "Customer" }];
    const home = { icon: "pi pi-home", url: "/" };
    const [brandData, setBrandData] = useState();
    const [showDialog, setShowDialog] = useState(false);
    const [showCreditDialog, setShowCreditDialog] = useState(false);
    const [creditDialogKey, setCreditDialogKey] = useState(0);
    const [email, setEmail] = useState("");
    const history = useHistory();
    const { id } = useParams();
    const [selectedDelivery, setSelectedDelivery] = useState(null);
    const [role, setRole] = useState();
    const [DeliveryInfos, setDeliveryInfos] = useState([]);
    const [couriers, setCouriers] = useState([]);
    const [selecCourier, setSelectCourier] = useState(null);
    const [creditHistoryKey, setCreditHistoryKey] = useState(0);

    const getDetails = async () => {
        const res = await handleGetRequest(`/getuser/${id}`);
        const res2 = await handleGetRequest(`/getAllDeliveryInfo`);
        const couriers = await handleGetRequest(`/userRole?role=courier`);
        setCouriers(couriers?.data);
        setDeliveryInfos(res2?.data);
        const keyData = res?.data;
        setEmail(res?.data?.email);
        setSelectCourier(res?.data?.courierBase);
        setBrandData(keyData);
        setRole(res?.data?.role);
        Object.keys(keyData).forEach((key) => {
            if (formik.initialValues.hasOwnProperty(key)) {
                formik.setFieldValue(key, keyData[key]);
            }
        });
        setSelectedDelivery(keyData?.deliveryInfo);
    };
    useEffect(() => {
        getDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: "",
            firstName: brandData?.firstName ?? "",
            lastName: "",
            phone: "",
            TRN: brandData?.client?.TRN ? brandData?.client?.TRN : brandData?.courier?.TRN ? brandData?.courier?.TRN : "",
            mailingAddress: brandData?.client?.mailingAddress ? brandData?.client?.mailingAddress : brandData?.courier?.mailingAddress ? brandData?.courier?.mailingAddress : "",
            deliveryAddress: brandData?.client?.deliveryAddress ? brandData?.client?.deliveryAddress : brandData?.courier?.deliveryAddress ? brandData?.courier?.deliveryAddress : "",
            businessName: brandData?.courier?.businessName ?? "",
            TCC: brandData?.courier?.TCC ?? "",
            businessType: brandData?.courier?.businessType ?? "",
            dateJoined: brandData?.courier?.dateJoined ?? "",
            deliveryInfo: brandData?.deliveryInfo ?? "",
            role: "",
            _id: "",
            courierBase: "",
            notes: brandData?.notes ?? "",
        },

        onSubmit: async (data) => {
            data._id = id;

            if (isClerk) {
                const clerkData = { _id: id, notes: data.notes };
                const result = await handlePutRequest(clerkData, "/Edituser");
                if (result?.success) {
                    getDetails();
                    toast.success("Notes updated");
                }
                return;
            }

            data.deliveryInfo = selectedDelivery;
            data.role = role;
            data.courierBase = selecCourier;
            const result = await handlePutRequest(data, "/Edituser");
            if (result?.success) {
                getDetails();
                toast.success("user Edited");
            }
        },
    });

    const handleCancel = () => {
        history.push("/customers");
    };

    const onHideTyreBrandsDialog = () => {
        setShowDialog(false);
    };

    const onsuccess = () => {
        onHideTyreBrandsDialog();
        toast.success("Password reset successfully.");
    };

    const onCreditGranted = () => {
        setShowCreditDialog(false);
        toast.success("Credit added to account");
        getDetails();
        setCreditHistoryKey((k) => k + 1);
    };

    const handleLocationSave = async (latitude, longitude) => {
        try {
            await handlePutRequest({ _id: id, latitude, longitude }, `/Edituser`);
            setBrandData((prev) => ({ ...prev, latitude, longitude }));
            toast.success("Location updated");
        } catch (error) {
            toast.error("Failed to update location");
        }
    };

    const showBusinessDetails = brandData?.role === "client" || brandData?.role === "courier" || brandData?.role === "corporate" || brandData?.role === "reseller";

    return (
        <div className={styles.customerPage}>
            <Dialog visible={showDialog} header="Reset Password" style={{ width: "650px" }} onHide={() => setShowDialog(false)}>
                <ResetPasswordDialog onHideTyreBrandsDialog={onHideTyreBrandsDialog} onsuccess={onsuccess} email={email} />
            </Dialog>
            <Dialog visible={showCreditDialog} header="Add Account Credit" style={{ width: "550px" }} onHide={() => setShowCreditDialog(false)}>
                <GrantCreditDialog
                    key={creditDialogKey}
                    clientId={id}
                    clientName={`${brandData?.firstName || ""} ${brandData?.lastName || ""}`.trim()}
                    onHideDialog={() => setShowCreditDialog(false)}
                    onsuccess={onCreditGranted}
                />
            </Dialog>

            <div className={styles.pageHeader}>
                <div>
                    <h2>
                        {brandData?.firstName} {brandData?.lastName}
                    </h2>
                    <BreadCrumb model={breadItems} home={home} />
                </div>
                {isClerk ? <p>View only mode (except Notes)</p> : <Button label="Reset Password" icon="pi pi-key" iconPos="right" onClick={() => setShowDialog(true)} className={styles.resetButton} />}
            </div>

            <form onSubmit={formik.handleSubmit}>
                <div className={styles.cardsGrid}>
                    <div className={styles.sectionCard}>
                        <h3>Personal Information</h3>
                        <div className={styles.field}>
                            <label htmlFor="firstName">First Name</label>
                            <InputText disabled={isClerk} id="firstName" name="firstName" value={formik.values.firstName} onChange={formik.handleChange} />
                        </div>
                        <div className={styles.field}>
                            <label htmlFor="lastName">Last Name</label>
                            <InputText disabled={isClerk} id="lastName" name="lastName" value={formik.values.lastName} onChange={formik.handleChange} />
                        </div>
                        <div className={styles.field}>
                            <label htmlFor="email">Email Address</label>
                            <InputText disabled={isClerk} id="email" name="email" value={formik.values.email} onChange={formik.handleChange} />
                        </div>
                        <div className={styles.field}>
                            <label htmlFor="phone">Phone Number</label>
                            <InputText disabled={isClerk} id="phone" name="phone" value={formik.values.phone} onChange={formik.handleChange} />
                        </div>
                    </div>

                    <div className={styles.sectionCard}>
                        <h3>Role &amp; Delivery Settings</h3>
                        <div className={styles.field}>
                            <label htmlFor="role">User Type</label>
                            <select disabled={isClerk} id="role" value={role} onChange={(e) => setRole(e.target.value)}>
                                <option disabled defaultValue="">
                                    Select Role
                                </option>
                                <option value="client">Client</option>
                                <option value="courier">Courier</option>
                                <option value="partner">Partner</option>
                                <option value="corporate">Corporate</option>
                                <option value="reseller">Reseller</option>
                            </select>
                        </div>
                        <div className={styles.field}>
                            <label htmlFor="deliveryInfo">Delivery Info</label>
                            <select disabled={isClerk} id="deliveryInfo" value={selectedDelivery} onChange={(e) => setSelectedDelivery(e.target.value)}>
                                <option disabled defaultValue="">
                                    Please select delivery information
                                </option>
                                {DeliveryInfos?.map((item) => (
                                    <option key={item.name} value={item.name}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className={styles.field}>
                            <label htmlFor="courierBase">Base Courier</label>
                            <select disabled={isClerk} id="courierBase" value={selecCourier} onChange={(e) => setSelectCourier(e.target.value)}>
                                <option disabled defaultValue="">
                                    Select courier base
                                </option>
                                {couriers?.map((item) => (
                                    <option key={item._id} value={item._id}>
                                        {item.courier?.businessName}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {showBusinessDetails && (
                        <div className={styles.sectionCard}>
                            <h3>Business Details</h3>
                            <div className={styles.field}>
                                <label htmlFor="TRN">TRN</label>
                                <InputText disabled={isClerk} id="TRN" name="TRN" value={formik.values.TRN} onChange={formik.handleChange} />
                            </div>
                            <div className={styles.field}>
                                <label htmlFor="mailingAddress">Mailing Address</label>
                                <InputText disabled={isClerk} id="mailingAddress" name="mailingAddress" value={formik.values.mailingAddress} onChange={formik.handleChange} />
                            </div>
                            <div className={styles.field}>
                                <label htmlFor="deliveryAddress">Delivery Address</label>
                                <InputText disabled={isClerk} id="deliveryAddress" name="deliveryAddress" value={formik.values.deliveryAddress} onChange={formik.handleChange} />
                            </div>
                            {brandData?.role === "courier" && (
                                <>
                                    <div className={styles.field}>
                                        <label htmlFor="businessName">Business Name</label>
                                        <InputText disabled={isClerk} id="businessName" name="businessName" value={formik.values.businessName} onChange={formik.handleChange} />
                                    </div>
                                    <div className={styles.field}>
                                        <label htmlFor="businessType">Business Type</label>
                                        <InputText disabled={isClerk} id="businessType" name="businessType" value={formik.values.businessType} onChange={formik.handleChange} />
                                    </div>
                                    <div className={styles.field}>
                                        <label htmlFor="TCC">TCC</label>
                                        <InputText disabled={isClerk} id="TCC" name="TCC" value={formik.values.TCC} onChange={formik.handleChange} />
                                    </div>
                                </>
                            )}
                        </div>
                    )}

                    {showBusinessDetails && (
                        <div className={styles.sectionCard}>
                            <h3>Account Credit</h3>
                            <div className={styles.creditRow}>
                                <div>
                                    <div className={styles.creditValue}>{formatMoney(brandData?.accountCreditBalance || 0)}</div>
                                    <p>Unallocated credit available toward this account's future invoices.</p>
                                </div>
                                {isAdmin && (
                                    <Button
                                        type="button"
                                        label="Add Credit"
                                        icon="pi pi-plus"
                                        onClick={() => { setCreditDialogKey((k) => k + 1); setShowCreditDialog(true); }}
                                    />
                                )}
                            </div>

                            {isAdmin && (
                                <div className={styles.creditHistory}>
                                    <p className={styles.creditHistoryTitle}>Credit History</p>
                                    <CreditHistoryList key={creditHistoryKey} clientId={id} />
                                </div>
                            )}
                        </div>
                    )}

                    <div className={styles.sectionCard}>
                        <h3>Location</h3>
                        {isClerk ? (
                            <div>
                                <p>Latitude: {brandData?.latitude || "N/A"}</p>
                                <p>Longitude: {brandData?.longitude || "N/A"}</p>
                                <p style={{ color: "#7f8c8d" }}>View only mode</p>
                            </div>
                        ) : (
                            <LocationPicker latitude={brandData?.latitude} longitude={brandData?.longitude} onSave={handleLocationSave} />
                        )}
                    </div>

                    {isAdmin && (
                        <div className={`${styles.sectionCard} ${styles.fullWidthCard}`}>
                            <AgentsManager userId={id} />
                        </div>
                    )}

                    <div className={`${styles.sectionCard} ${styles.fullWidthCard}`}>
                        <h3>Notes</h3>
                        <div className={styles.field}>
                            <InputTextarea id="notes" name="notes" value={formik.values.notes} onChange={formik.handleChange} rows={5} placeholder="Add any additional notes here..." />
                        </div>
                    </div>
                </div>

                <div className={styles.actionsFooter}>
                    <Button type="button" label="Cancel" className={styles.cancelButton} onClick={handleCancel} />
                    <Button type="submit" label={isClerk ? "Update Notes" : "Update"} className={styles.saveButton} disabled={isClerk && viewOnly} />
                </div>
            </form>
        </div>
    );
}

export default Customer;
